import { Link } from "react-router-dom";
import FoodCard from "@/components/base/FoodCard";
import { foods } from "@/mocks/foods";

const featured = [
  "beef-noodle",
  "salmon-steak",
  "matcha-mille",
  "cheese-burger",
  "shrimp-dumpling",
  "mango-cheese",
]
  .map((id) => foods.find((f) => f.id === id))
  .filter(Boolean) as typeof foods;

export default function FeaturedFoods() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-bold text-primary-700">
              <i className="ri-fire-line" />
              美食精选
            </span>
            <h2 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">
              今天，想吃点什么好东西
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              从热腾腾的面食到精致的甜点饮品，严选商家 · 现点现做 · 极速送达，让每一餐都不将就。
            </p>
          </div>
          <Link
            to="/food-category"
            className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition hover:bg-primary-50"
          >
            查看全部美食
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div data-product-shop className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((food) => (
            <FoodCard key={food.id} food={food} />
          ))}
        </div>
      </div>
    </section>
  );
}